import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "@/store/authStore";
import { auth } from "@/api/endpoints";
import { ApiError } from "@/api/client";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const { setToken, setUser } = useAuthStore();
  const nav = useNavigate();

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const { access_token } = await auth.login(username, password);
      setToken(access_token);
      setUser(await auth.me());
      nav("/dashboard");
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center">
      <form onSubmit={submit} className="bg-white p-8 rounded-lg shadow-sm border border-slate-200 w-80">
        <h1 className="text-xl font-semibold mb-1">ProvCRM</h1>
        <p className="text-sm text-slate-500 mb-6">Sign in with your Tempo credentials.</p>
        {error && <div className="mb-3 text-sm text-red-600">{error}</div>}
        <label className="block text-sm mb-1">Username</label>
        <input
          className="w-full border border-slate-300 rounded px-3 py-2 mb-3 text-sm"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          autoFocus
        />
        <label className="block text-sm mb-1">Password</label>
        <input
          type="password"
          className="w-full border border-slate-300 rounded px-3 py-2 mb-4 text-sm"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button
          type="submit"
          disabled={busy}
          className="w-full bg-slate-900 text-white rounded py-2 text-sm disabled:opacity-50"
        >
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
